export default __webpack_public_path__ + "static/icon_credit-card-646d3eebca81f78ce7f8b9dc9fd80f01.png";